import {Negotiation} from "@/modules/diplomacy/entity";
import type {Relation} from "typeorm";
import {ChildEntity, Column, ManyToOne} from "typeorm";
import {Player} from "@/modules/team/entity/Player";
import {Max, Min} from "class-validator";

@ChildEntity()
export class PlayerContractNegotiation extends Negotiation {
  @ManyToOne(() => Player)
  declare target: Relation<Player>;

  @Column({type: 'integer'})
  @Min(1)
  @Max(5)
  years: number;

  @Column({type: 'integer'})
  @Min(1)
  @Max(5)
  playerTargetYears: number;

  get negotiationCurrentYears() {
    return Math.floor(
      this.playerTargetYears - (this.playerTargetYears - this.years) * this.progress / 100
    );
  }
}
